export default __webpack_public_path__ + "static/media/product3.72ad8326.jpg";